import ApiService from '../apiservice'

export default class RodizioUsuarioService extends ApiService {
	constructor() {
		super('/rodizio')
	}

	incluirRodizio(request) {
		return this.post('/incluir-rodizio',request);
	}

	consultarRodizio(grupoId,tituloId) {
		return this.get(`/consultar-rodizio/${grupoId}/${tituloId}`);
	}

	consultarPorGrupoTrabalho(grupoTrabalhoId,grupoAtividadeId) {
		return this.get(`/consultar-por-grupo-trabalho/${grupoTrabalhoId}/${grupoAtividadeId}`);
	}

	buscarRodizio(grupoTrabalhoId, grupoAtividadeId) {
		return this.get(`/buscar-rodizio/${grupoTrabalhoId}/${grupoAtividadeId}`);
	}

	excluirUsuarioRodizio(usuarioRodizioId) {
		return this.delete(`/excluir-usuario-rodizio/${usuarioRodizioId}`);
	}

	alterarRodizio(request) {
		return this.put('/alterar-rodizio',request);
	}
}
